import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { validateToken, checkSessionExpiration } from '../../utils/sessionUtils';

interface PrivateRouteProps {
  element: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const intervalRef = useRef<number | NodeJS.Timer | null>(null);

  useEffect(() => {
    const isValid = validateToken();
    setIsAuthenticated(isValid);
    setIsLoading(false);

    intervalRef.current = checkSessionExpiration();
    return () => {
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Component {...rest} />;
  } else {
    return <Navigate to="/auth/login" state={{ from: location }} />;
  }
};

export default PrivateRoute;
